import { render } from "./ButtonUp.vue?vue&type=template&id=ec10729e"
import script from "./ButtonUp.vue?vue&type=script&lang=js"
export * from "./ButtonUp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__